export default __webpack_public_path__ + "static/media/true.9d8cf9ff.svg";